import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

export type SaveTransactionMethodArgs = {
  transactionId: number;
  name?: string;
};
export type SaveTransactionMethodResponse = {
  saveTransactionMethod: DefaultApiResponse<boolean>;
};
export const saveTransactionMethodMutation: TypedDocumentNode<
  SaveTransactionMethodResponse,
  DefaultArg<SaveTransactionMethodArgs>
> = gql`
  mutation SaveTransactionMethod($record: SaveTransactionUsedMethodRecord!) {
    saveTransactionMethod(record: $record)
  }
`;
